const COLOR = {
  'black': 'black',
  'dark chocolate': '#3c1321',
  'royal blue': '#0037a0',
  'white': 'white',
  'heather grey': '#bebbbb',
  'cool blue': '#429bb8',
  'mint': '#cfffe5',
  'pink': '#ffc0cb',
  'navy': '#000080',
  'kelly green': '#5aa27c',
  'green': 'green',
  'yellow': 'yellow',
  'grey': 'grey',
  'red': 'red',
  'blue': 'blue',
  'royal': '#2f5995',
  'forest': '#014421',
  'kelly': '#4cbb17',
  'deep forest': '#154741',
  'deep royal': '#131B3b',
  'irish green': '#215923',
  'graphite heather': '#626464',
  'graphite': '#726e6b',
  'athletic heather': '#b1afb4'
}

var products = [];

$(function() {
  // Promo banner
  (function() {
    $('.promo-cancel').click(function() {
      $('.promo-banner').remove();
    });
  })();

  (function() {
    // Large header
    if($(window).width() >= 1024) {
      $('.menu-item, .header-menu').mouseenter(function(e) {
        if(e.target === this) {
          $('.large-expanded-menu').stop(true).hide();
        }
      });

      $('.expandable').hover(
        function() {
          const expandedMenu = $(this);

          $.each($('.large-expanded-menu'), function(index, menu) {
            if($(menu).data('title') === expandedMenu.text().trim()) {
              $(menu).fadeIn(300);
              $(menu).css('display', 'grid');

              $(menu).mouseleave(function() {
                $(menu).hide();
              });
            }
          });
        }
      );
      
      // Sticky header

      $(window).bind('scroll', function() {
        if($(window).scrollTop() > 600) {
          $('.sticky').fadeIn(300);
          $('.sticky').css('display', 'grid');
          $('.large-expanded-menu').addClass('sticky-expanded');
          $('.large-main-header').css('grid-template-rows', '68px');
        } else {
          $('.sticky').stop(true).hide();
          $('.large-expanded-menu').removeClass('sticky-expanded');
          $('.large-main-header').css('grid-template-rows', '100px');
        }
      });
      
    } else {
      // Small header
      $('.btn-search').click(function() {
        if($('.small-expanded-menu:visible').length > 0) {
          $('.small-expanded-menu').stop(true).hide();
        }

        if($('.header-search-form:visible').length > 0) {
          $('.header-search-form').stop(true).hide();
        } else {
          $('.header-search-form').fadeIn(300);
          $('.header-search-form').css('display', 'grid'); 
        }
      });

      $('.btn-menu').click(function() {
        if($('.header-search-form:visible').length > 0) {
          $('.header-search-form').stop(true).hide();
        }

        if($('.small-expanded-menu:visible').length > 0) {
          $('.small-expanded-menu').stop(true).hide();
        } else {
          $('.small-expanded-menu').fadeIn(300);
          $('.small-expanded-menu').css('display', 'grid');
        }
      });

      $('a[class*=expandable]').click(function() {
        if($(this).next('span:visible').length > 0) {
          $(this).next('span').stop(true).hide();
          $(this).children('svg').css('transform', 'rotate(0)');
        } else {
          $(this).next('span').fadeIn(300);
          $(this).children('svg').css('transform', 'rotate(90deg)');
          $(this).next('span').css('display', 'grid');
        }
      });
    }
  })();

  // Set best choices title
  (function() {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    var bestChoicesTitle = null;

    $.each($('.section-title'), function(index, title) {
      if($(title).text().toLowerCase() === 'best choices') {
        bestChoicesTitle = $(title);
        return false;
      }
    });

    if(bestChoicesTitle !== null) {
      const currentTime = new Date();
      bestChoicesTitle.text('Best choices in ' + monthNames[currentTime.getMonth()]);
    }
  })();

  // Footer
  (function() {
    if($(window).width() >= 800) {
      return false;
    }

    $('.footer-title').click(function() {
      if($(this).next('.footer-content:visible').length > 0) {
        $(this).children('svg').css('transform', 'rotate(0)');
        $(this).next('.footer-content').stop(true).hide();
      } else {
        $(this).next('.footer-content').fadeIn(300);
        $(this).children('svg').css('transform', 'rotate(90deg)');
        $(this).next('.footer-content').css('display', 'grid');
      }
    });
  })();

  // Cart quantity

  (function() {
    $('.decrease').click(function() {
      const currentInputVal = parseInt($(this).next('input').val());
      if(currentInputVal > 1) {
        $(this).next('input').val(currentInputVal - 1);
        $('button[name=update]').trigger('click');
      }
    });

    $('.increase').click(function() {
      const currentInputVal = parseInt($(this).prev('input').val());
      $(this).prev('input').val(currentInputVal + 1);
      $('button[name=update]').trigger('click');
    });
  })();

  // Judge
  
  (function() {
    if($('#judgeme_product_reviews').length === 0 && $('#judgeme_all_reviews_page').length === 0) {
      return false;
    }

    var totalStars = 0;
    var totalRated = 0;

    if($('.jdgm-all-reviews__summary-text').length > 0) {

    }

    $.each($('.jdgm-histogram__row'), function(index, row) {
      if($(row).data('rating') !== null && $(row).data('frequency') !== null) {
        totalStars += $(row).data('rating') * $(row).data('frequency');
        totalRated += $(row).data('frequency');  
      }
    });

    if(isNaN(totalStars / totalRated)) {
      if($('.jdgm-all-reviews__summary-text').length > 0) {
        $('.jdgm-all-reviews__summary-text').width('100%');
      }

      if($('.jdgm-rev-widg__summary-text').length > 0) {
        $('.jdgm-rev-widg__summary-text').width('100%');
      }

      $('.jdgm-write-rev-link').css({
        'margin-right': '50%',
        'margin-top': '20px',
        'transform': 'translateX(50%)'
      });

      if($('.jdgm-all-reviews__summary').length > 0) {
        $('.jdgm-all-reviews__summary').css({
          'margin-left': '50%',
          'transform': 'translateX(-50%)'
        });
      }

      if($('.jdgm-rev-widg__summary').length > 0) {
        $('.jdgm-rev-widg__summary').css({
          'margin-left': '50%',
          'transform': 'translateX(-50%)'
        });
      }
    } else {
      if($('.jdgm-all-reviews__summary-stars').length > 0) {
        $('<p>' + (totalStars / totalRated).toFixed(1) + '</p>').insertAfter($('.jdgm-all-reviews__summary-stars'));
      }

      if($('.jdgm-rev-widg__summary-stars').length > 0) {
        $('<p>' + (totalStars / totalRated).toFixed(1) + '</p>').insertAfter($('.jdgm-rev-widg__summary-stars'));
      }
    }

    $.each($('.jdgm-histogram__frequency'), function(index, freq) {
      const freqText = $(freq).text();
      $(freq).text(freqText.substring(1, 2));
    });

    $('.jdgm-write-rev-link').click(function() {
      $('.jdgm-form-wrapper').toggle();
      $('.jdgm-submit-rev').val('Submit your review');
      $('.jdgm-form__body-fieldset label').text('Your overall experience');
    });

    $.each($('.jdgm-histogram__star'), function(index, row) {
      $(row).children('.jdgm-star').remove();
      $(row).text(5 - index + ' Star');
    });
  })();
});